<script lang="ts">
	import { closeOverlay } from "overlay"
	import { Responsive } from "responsive"

	/** Gorgias help-center article hosting the custom-show order form. */
	const ORDER_FORM_URL =
		"https://luxcourts.gorgias.help/en-US/7801269-9b3da4fd6ab540f6bcef9f44a208fc5b"

	let isMobile = $derived(Responsive.isMobile)

	function openOrderForm() {
		window.open(ORDER_FORM_URL, "_blank", "noopener,noreferrer")
	}
</script>

<div id="pro-content-solutions" class:isMobile>
	<h1>Need New shows?</h1>
	<p>
		Simply complete this quick order form and our content team will begin the process of
		collaborating with you to make the magic happen!
	</p>
	<span class="hint">You can come back any time — find Content Solutions in the sidebar.</span>
	<div class="button-container">
		<button class="outline-button" onclick={openOrderForm}>Start My Order</button>
		<button class="outline-button alt" onclick={() => closeOverlay()}>Maybe later</button>
	</div>
</div>

<style>
	#pro-content-solutions {
		max-width: 40vw;
		padding-bottom: 2rem;
	}

	#pro-content-solutions.isMobile {
		max-width: unset;
		padding-bottom: 3rem;
	}

	h1 {
		margin: 1rem 0 1rem 0;
		font-size: var(--h0);
	}

	.isMobile h1 {
		font-size: var(--h1);
	}

	.isMobile p {
		line-height: 1.3;
	}

	.hint {
		color: var(--color-main);
	}

	.button-container {
		width: fit-content;
		position: absolute;
		bottom: 0.5rem;
	}

	.button-container button {
		margin-right: 1rem;
	}

	.isMobile button {
		padding: 0 1rem;
		margin: 0;
	}

	.isMobile .button-container {
		width: calc(100% - 2rem);
		align-items: center;
		gap: 0;
	}
</style>
